import styled, { css } from 'styled-components';
import { Select } from 'src/components';

export { SectionContainer, CardsContainer } from '../styles';

export const SourceLanguageText = styled.span`
  color: ${({ theme }) => theme.co.neutral20};
  font-family: ${({ theme }) => theme.DEPRECATED_ty.openSans};
  font-size: ${({ theme }) => theme.DEPRECATED_ty.medium};
  font-weight: ${({ theme }) => theme.DEPRECATED_ty.bold};
  margin: 0 ${({ theme }) => theme.sz.s2};

  @media (min-width: ${({ theme }) => theme.sz.ms}) {
    font-size: ${({ theme }) => theme.DEPRECATED_ty.large};
  }
`;

export const SourceLanguageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${({ theme }) => theme.sz.s4} auto;
  text-align: center;

  & > * {
    margin-bottom: ${({ theme }) => theme.sz.s2};
  }

  @media (min-width: ${({ theme }) => theme.sz.ms}) {
    align-items: baseline;
    flex-direction: row;
    margin: ${({ theme }) => theme.sz.s16} auto ${({ theme }) => theme.sz.s12} auto;
    text-align: left;
    width: 100%;

    & > * {
      margin-bottom: 0;
    }
  }
`;

export const StyledSelect = styled(Select)(
  ({ theme }) => css`
    select {
      min-width: ${theme.sz.s64};
      text-transform: none;
      font-family: ${theme.DEPRECATED_ty.openSans};
      option {
        font-family: ${theme.DEPRECATED_ty.openSans};
        font-weight: ${theme.DEPRECATED_ty.mediumWeight};
      }
    }
  `,
);

export const MediaCardContainer = styled.div(
  ({ theme }) => css`
    position: relative;
    width: 100%;
    transition:
      transform 0.3s ease,
      translateY 0.3s ease;
    &:hover {
      transform: translateY(-${theme.sz.s1});
    }
    @media (min-width: ${theme.sz.sm}) {
      width: auto;
    }
  `,
);

export const FlagContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.neutral60};
    border-radius: ${theme.bo.round};
    height: ${theme.sz.s10};
    left: ${theme.sz.s4};
    position: absolute;
    top: ${theme.sz.s4};
    width: ${theme.sz.s10};

    &img {
      height: ${theme.sz.s10};
      width: ${theme.sz.s10};
    }

    @media (min-width: ${theme.sz.sm}) {
      left: 50%;
      top: ${theme.sz.s40};
      margin-left: -${theme.sz.s5};
    }

    @media (min-width: ${theme.sz.xl}) {
      top: calc(${theme.sz.s40} + ${theme.sz.s1});
    }
  `,
);

export const FlagImg = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s10};
    width: ${theme.sz.s10};
  `,
);
